import Vue from 'vue'
import VueRouter from 'vue-router'
import TrackingVue from '../views/TrackingVue'

const LoginView = () => import(/* webpackChunkName: "login" */ '../views/LoginView')
const RecoverPasswordView = () => import(/* webpackChunkName: "login" */ '../views/RecoverPasswordView')
const RecoverPasswordFormView = () => import(/* webpackChunkName: "login" */ '../views/RecoverPasswordFormView')
const StoreView = () => import(/* webpackChunkName: "store" */ '../views/StoreView')
const StoreDetailView = () => import(/* webpackChunkName: "store" */ '../views/StoreDetailView')
const UserView = () => import(/* webpackChunkName: "user" */ '../views/UserView')
const StoreDeliveryView = () => import(/* webpackChunkName: "store" */ '../views/StoreDeliveryView')
const RegionView = () => import(/* webpackChunkName: "region" */ '../views/RegionView')
const RegionDetailView = () => import(/* webpackChunkName: "region" */ '../views/RegionDetailView')
const MyStoreView = () => import(/* webpackChunkName: "store" */ '../views/MyStoreView')
const StoreWithdrawalsView = () => import(/* webpackChunkName: "store" */ '../views/StoreWithdrawalsView')
const GroupView = () => import(/* webpackChunkName: "group" */ '../views/GroupView')
const MessageView = () => import(/* webpackChunkName: "message" */ '../views/MessageView')
const PackageReceiveView = () => import(/* webpackChunkName: "package" */ '../views/PackageReceiveView.vue')
const DeliverysView = () => import(/* webpackChunkName: "delivery" */ '../views/DeliverysView')
const DeliveryDetailView = () => import(/* webpackChunkName: "delivery" */ '../views/DeliveryDetailView')
const DeliveryCompleteView = () => import(/* webpackChunkName: "delivery" */ '../views/DeliveryCompleteView')
const DeliveryPDF = () => import(/* webpackChunkName: "delivery" */ '../views/DeliveryPDF')
const ScannerInStoreView = () => import(/* webpackChunkName: "scanner" */ '../views/ScannerInStoreView.vue')
const IntegrationView = () => import(/* webpackChunkName: "integration" */ '../views/IntegrationView.vue')
const DriverAssignmentRequestsView = () => import(/* webpackChunkName: "delivery" */ '../views/DriverAssignmentRequestsView.vue')
const ScannerPackagesForDriverAssignmentView = () => import(/* webpackChunkName: "delivery" */ '../views/ScannerPackagesForDriverAssignmentView.vue')
const PickUpRequests = () => import(/* webpackChunkName: "delivery" */ '../views/PickUpRequests.vue')
const ManagementControlView = () => import(/* webpackChunkName: "management" */ '../views/ManagementControlView.vue')
const SettlementGoogleSheetsConfigView = () => import(/* webpackChunkName: "settlement" */ '../views/SettlementGoogleSheetsConfigView.vue')
const JumpsellerOAuthCallbackView = () => import(/* webpackChunkName: "jumpseller" */ '../views/JumpsellerOAuthCallbackView.vue')
const JumpsellerAppView = () => import(/* webpackChunkName: "jumpseller" */ '../views/JumpsellerAppView.vue')
const MercadolibreOAuthCallbackView = () => import(/* webpackChunkName: "mercadolibre" */ '../views/MercadolibreOAuthCallbackView.vue')
const WebhookEventsView = () => import(/* webpackChunkName: "webhook-events" */ '../views/WebhookEventsView.vue')


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/tracking',
    name: 'Tracking',
    component: TrackingVue,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/prueba-entrega/:id',
    name: 'DeliveryPDF',
    component: DeliveryPDF,
    meta: {
      isPublic: true,
      hideHeaderAndFooter: true
    }
  },
  {
    path: '/recuperar-password',
    name: 'Recover Password',
    component: RecoverPasswordView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/recuperar-password-form/:token',
    name: 'Recover Password Form',
    component: RecoverPasswordFormView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/tiendas',
    name: 'StoreView',
    component: StoreView
  },
  {
    path: '/usuarios',
    name: 'UserView',
    component: UserView
  },
  {
    path: '/tiendas/:storeId',
    name: 'StoreDatilView',
    component: StoreDetailView
  },
  {
    path: '/envios-tienda',
    name: 'StoreDeliveryView',
    component: StoreDeliveryView
  },
  {
    path: '/mis-envios',
    name: 'DeliverysView',
    component: DeliverysView
  },
  {
    path: '/mis-envios/:deliveryId',
    name: 'DeliveryDetailView',
    component: DeliveryDetailView
  },
  {
    path: '/retiros-tienda',
    name: 'StoreWithdrawalsView',
    component: StoreWithdrawalsView
  },
  {
    path: '/regiones',
    name: 'RegionView',
    component: RegionView
  },
  {
    path: '/regiones/:regionId',
    name: 'RegionDetailView',
    component: RegionDetailView
  },
  {
    path: '/mi-tienda',
    name: 'MyStoreView',
    component: MyStoreView
  },
  {
    path: '/grupos',
    name: 'GroupView',
    component: GroupView
  },
  {
    path: '/mensajes',
    name: 'MessageView',
    component: MessageView
  },
  {
    path: '/recepcion-de-paquetes/:code',
    name: 'PackageReceiveView',
    component: PackageReceiveView,
    meta: {
      onlyAdmin: true
    }
  },
  {
    path: '/escaner-en-tienda',
    name: 'ScannerInStore',
    component: ScannerInStoreView,
    meta: {
      isPublic: false,
      back: { name: 'Home' },
      title: 'Escaner retiro en tienda',
      roles: ['driver', 'warehouse', 'admin', 'viewer']
    }
  },
  {
    path: '/recepcion-en-bodega',
    name: 'ReceivedInWarehouse',
    component: ScannerInStoreView,
    meta: {
      isPublic: false,
      back: { name: 'Home' },
      title: 'Recepcionar retiro en bodega',
      roles: ['driver', 'warehouse', 'admin', 'viewer']
    }
  },
  {
    path: '/escaner-ruta-conductor',
    name: 'pickedUpByDriver',
    component: ScannerInStoreView,
    meta: {
      isPublic: false,
      back: { name: 'Home' },
      title: 'Escanear ruta conductor',
      roles: ['driver', 'warehouse', 'admin', 'viewer']
    }
  },
  {
    path: '/cambios-devoluciones',
    name: 'ExchangeOrReturn',
    component: ScannerInStoreView,
    meta: {
      isPublic: false,
      back: { name: 'Home' },
      title: 'Cambio o devoluciones',
      roles: ['driver', 'warehouse', 'admin', 'viewer']
    }
  },
  {
    path: '/completar-envio/:deliveryId',
    name: 'DeliveryCompleteView',
    component: DeliveryCompleteView
  },
  {
    path: '/integraciones',
    name: 'IntegrationView',
    component: IntegrationView,
    meta: {
      isPublic: false,
      roles: ['admin', 'store'],
      title: 'Integración Shopify'
    }
  },
  {
    path: '/integraciones/jumpseller/callback',
    name: 'JumpsellerOAuthCallbackView',
    component: JumpsellerOAuthCallbackView,
    meta: {
      isPublic: true,
      hideHeaderAndFooter: true,
      title: 'Integración Jumpseller'
    }
  },
  {
    path: '/integraciones/mercadolibre/callback',
    name: 'MercadolibreOAuthCallbackView',
    component: MercadolibreOAuthCallbackView,
    meta: {
      isPublic: true,
      hideHeaderAndFooter: true,
      title: 'Integración Mercado Libre'
    }
  },
  {
    path: '/integraciones/jumpseller/app',
    name: 'JumpsellerAppView',
    component: JumpsellerAppView,
    meta: {
      isPublic: true,
      hideHeaderAndFooter: true,
      title: '12 Horas Envíos para Jumpseller'
    }
  },
  {
    path: '/asignaciones-conductores',
    name: 'DriverAssignmentRequestsView',
    component: DriverAssignmentRequestsView,
    meta: {
      onlyAdmin: true
    }
  },
  {
    path: '/asignaciones-conductores/escanear-paquetes',
    name: 'ScannerPackagesForDriverAssignment',
    component: ScannerPackagesForDriverAssignmentView,
    meta: {
      isPublic: false,
      roles: ['driver', 'warehouse']
    }
  },
  {
    path: '/solicitudes-retiro',
    name: 'PickUpRequests',
    component: PickUpRequests
  },
  {
    path: '/control-de-gestion',
    name: 'ManagementControlView',
    component: ManagementControlView
  },
  {
    path: '/configuracion',
    name: 'SettlementGoogleSheetsConfigView',
    component: SettlementGoogleSheetsConfigView,
    meta: {
      onlyAdmin: true,
      title: 'Config'
    }
  },
  {
    path: '/eventos-webhook',
    name: 'WebhookEventsView',
    component: WebhookEventsView,
    meta: {
      onlyAdmin: true,
      title: 'Eventos de webhooks'
    }
  }
]

// Ruta de demo del UI Kit: solo disponible en desarrollo (no se compila en producción).
if (process.env.NODE_ENV !== 'production') {
  routes.push({
    path: '/ui-kit',
    name: 'UiKit',
    component: () => import(/* webpackChunkName: "ui-kit" */ '../views/UiKitView'),
    meta: {
      isPublic: true,
      hideHeaderAndFooter: true,
      title: 'UI Kit'
    }
  })
}



const router = new VueRouter({
  mode: 'history',
  routes
})

router.onError((error) => {
  const targetPath = error.config?.url || '';

  if (error.name === 'ChunkLoadError' || error.message.includes('Loading chunk')) {
    window.location.reload();
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.onlyAdmin) {
    const isAdmin = JSON.parse(localStorage.getItem('user')).user.role === 'admin'

    if (isAdmin) {
      // User is authenticated, proceed to the route
      next()
    } else {
      // User is not authenticated, redirect to home
      next('/')
    }
  } else {
    // Non-protected route, allow access
    next()
  }
})

export default router
